import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { authMe, authLogout } from '../services/api';

const AuthContext = createContext({
  user: null,
  loading: true,
  refresh: async () => {},
  logout: async () => {},
  setUser: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
      return u;
    } catch (err) {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    await authLogout();
    setUser(null);
  }, []);

  useEffect(() => {
    // If returning from Google OAuth (session_id in hash), skip /me check
    // AuthCallback will exchange session_id then refresh us.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const hasRole = (user, ...roles) => !!user && roles.includes(user.role);
export const isAdmin = (user) => hasRole(user, 'super_admin', 'admin');
export const isSuperAdmin = (user) => hasRole(user, 'super_admin');
